'use client';

// This component is necessary to establish the "use client" boundary in front of the @uploadcare/nextjs-loader component.
// Otherwise, I'd be needing to mark every component using it as a client component (with "use client").

import Component from '@uploadcare/nextjs-loader';
import type { ImageProps } from 'next/image';

type Props = ImageProps;

export function UploadcareImage({ src, ...attributes }: Props) {
    return <Component {...attributes} src={withoutFilename(src)} />;
}

/**
 * Apparently, the `@uploadcare/nextjs-loader` component does not like when there is a filename in the Uploadcare Image URL.
 * E.g:
 * - Passing "https://cdn.uc.assets.prezly.com/69093b2e-b0d9-4df1-8047-e5aeb573fdc6/" works
 * - Passing "https://cdn.uc.assets.prezly.com/69093b2e-b0d9-4df1-8047-e5aeb573fdc6/image.svg" causes troubles.
 *
 * So with this function we're making sure the component works no matter what.
 */
function withoutFilename<T>(src: string | T): string | T {
    if (typeof src === 'string' && !src.endsWith('/')) {
        const pos = src.lastIndexOf('/');
        if (pos >= 0) {
            return src.substring(0, pos + 1);
        }
    }
    return src;
}
